module.exports = __webpack_public_path__ + "img/fwzt07_1.4c99c5f.png";